<template>
    <div id="app">
        <keep-alive>
            <router-view/>
        </keep-alive>
        <div id="loading" class="hide">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">数据加载中</p>
            </div>
        </div>
    </div>
</template>

<script>
  var dsBridge = require("dsbridge");
  //alert('dsbridge:' + JSON.stringify(dsBridge));
  if(window.dsBridge){
    dsBridge.call("getCity", {}, function (city) {
      window.sessionStorage.setItem("city",city);
    });
    window.sessionStorage.setItem("session",dsBridge.call("getSession", {}));
  }
    export default {
        name: 'App'
    }
</script>



// WEBPACK FOOTER //
// src/ally/App.vue